import { render, staticRenderFns } from "./EditOverlay.vue?vue&type=template&id=1daa3281&"
import script from "./EditOverlay.js?vue&type=script&lang=js&"
export * from "./EditOverlay.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/staging.mijnmooiestraat.vlaanderen/pro-staging.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1daa3281')) {
      api.createRecord('1daa3281', component.options)
    } else {
      api.reload('1daa3281', component.options)
    }
    module.hot.accept("./EditOverlay.vue?vue&type=template&id=1daa3281&", function () {
      api.rerender('1daa3281', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/EditOverlay/EditOverlay.vue"
export default component.exports